import {
  GET_REPORT_PRODUCT_PENDING,
  GET_REPORT_PRODUCT_SUCCESS,
  GET_REPORT_PRODUCT_ERROR,
  EXPORT_REPORT_PRODUCT_PENDING,
  EXPORT_REPORT_PRODUCT_SUCCESS,
  EXPORT_REPORT_PRODUCT_ERROR,
  REPORT_PRODUCT_DATA,
  SET_REPORT_PRODUCT_MODAL,
} from "../../../actions/report/product";

const initialState = {
  pending: false,
  error: null,
  data: null,
  detailData: null,
  isOpenModal: false,
  modalType: "",
};

const product = (state = initialState, action) => {
  switch (action.type) {
    case GET_REPORT_PRODUCT_PENDING:
      return {
        ...state,
        pending: true,
      };
    case GET_REPORT_PRODUCT_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case GET_REPORT_PRODUCT_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case EXPORT_REPORT_PRODUCT_PENDING:
      return {
        ...state,
        pending: true,
      };
    case EXPORT_REPORT_PRODUCT_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case EXPORT_REPORT_PRODUCT_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case REPORT_PRODUCT_DATA:
      return {
        ...state,
        detailData: action.data,
      };
    case SET_REPORT_PRODUCT_MODAL:
      return {
        ...state,
        isOpenModal: action.data.isOpen,
        modalType: action.data.modalType,
      };
    default:
      return state;
  }
};

export default product;
